<template>
  <div class="login-card">
    <!-- 弹窗关闭按钮 -->
    <div v-if="modalMode" class="login-card__close" @click="$emit('close')">
      <span>×</span>
    </div>

    <!-- 顶部账号类型切换：个人账号 / 企业账号 -->
    <div class="login-card__account-tabs">
      <div
        class="login-card__account-tab"
        :class="{ 'login-card__account-tab--active': accountType === 'personal' }"
        @click="switchAccountType('personal')"
      >
        个人账号
      </div>
      <div
        class="login-card__account-tab"
        :class="{ 'login-card__account-tab--active': accountType === 'company' }"
        @click="switchAccountType('company')"
      >
        企业账号
      </div>
    </div>

    <!-- 欢迎登录 / 注册账号 切换 -->
    <div class="login-card__sub-tabs" v-if="view === 'login' || view === 'register'">
      <div
        class="login-card__sub-tab"
        :class="{ 'login-card__sub-tab--active': view === 'login' }"
        @click="switchView('login')"
      >
        欢迎登录
      </div>
      <div
        class="login-card__sub-tab"
        :class="{ 'login-card__sub-tab--active': view === 'register' }"
        @click="switchView('register')"
      >
        注册账号
      </div>
    </div>

    <!-- 登录表单 -->
    <div v-show="view === 'login'" class="login-card__form">
      <div class="login-card__form-item">
        <div class="login-card__input-wrap">
          <img class="login-card__input-icon login-card__input-icon--phone" src="./assets/img/FigmaDDSSlicePNG5aefd021dfa26ee89db1bfbb808c4104.png" alt="phone" />
          <div class="login-card__input-divider"></div>
          <input
            v-model="loginForm.phone"
            class="login-card__input"
            type="text"
            placeholder="请输入手机号"
            maxlength="11"
          />
        </div>
        <div v-if="loginForm.errors.phone" class="login-card__error">
          <span>{{ loginForm.errors.phone }}</span>
        </div>
      </div>

      <div class="login-card__form-item">
        <div class="login-card__input-wrap">
          <img class="login-card__input-icon login-card__input-icon--lock" src="./assets/img/FigmaDDSSlicePNGa25834c98b83a5353b3241915865c83f.png" alt="lock" />
          <div class="login-card__input-divider"></div>
          <input
            v-model="loginForm.password"
            class="login-card__input"
            :type="showPassword ? 'text' : 'password'"
            placeholder="请输入登录密码"
          />
        </div>
        <div v-if="loginForm.errors.password" class="login-card__error">
          <span>{{ loginForm.errors.password }}</span>
        </div>
      </div>

      <!-- 验证码 -->
      <div class="login-card__form-item">
        <div class="login-card__input-wrap login-card__input-wrap--code">
          <input
            v-model="loginForm.captchaCode"
            class="login-card__input"
            type="text"
            placeholder="请输入图片验证码"
            maxlength="4"
          />
          <div class="login-card__captcha-image" @click="refreshCaptcha">
            <img v-if="captchaUrl" :src="captchaUrl" alt="captcha" />
            <div v-else class="captcha-placeholder">点击获取</div>
          </div>
        </div>
        <div v-if="loginForm.errors.captcha" class="login-card__error">
          <span>{{ loginForm.errors.captcha }}</span>
        </div>
      </div>

      <div class="login-card__options">
        <label class="login-card__checkbox-wrap">
          <input v-model="loginForm.autoLogin" type="checkbox" class="login-card__checkbox" />
          <span class="login-card__checkbox-label">下次自动登录</span>
        </label>
        <span class="login-card__forgot" @click="switchView('forgot')">忘记密码</span>
      </div>

      <!-- 协议勾选 -->
      <div class="login-card__agree-row">
        <div 
          class="login-card__agree-box" 
          :class="{ 'login-card__agree-box--checked': loginForm.agreed }"
          @click="loginForm.agreed = !loginForm.agreed"
        >
          <div class="login-card__agree-inner" v-if="loginForm.agreed"></div>
        </div>
        <span class="login-card__agree-text">
          我已阅读并同意
          <a href="/user-agreement" target="_blank" class="agree-link">《用户协议》</a>
          和
          <a href="/privacy-terms" target="_blank" class="agree-link">《隐私政策》</a>
        </span>
      </div>

      <div v-if="loginError" class="login-card__form-error">
        <span>{{ loginError }}</span>
      </div>

      <button class="login-card__submit" @click="handleLogin">
        <span>登 录</span>
      </button>
    </div>

    <!-- 注册表单 -->
    <div v-show="view === 'register'" class="login-card__form">
      <div class="login-card__form-item">
        <div class="login-card__input-wrap">
          <img class="login-card__input-icon login-card__input-icon--phone" src="./assets/img/FigmaDDSSlicePNG5aefd021dfa26ee89db1bfbb808c4104.png" alt="phone" />
          <div class="login-card__input-divider"></div>
          <input
            v-model="registerForm.phone"
            class="login-card__input"
            type="text"
            placeholder="请输入手机号"
            maxlength="11"
          />
        </div>
        <div v-if="registerForm.errors.phone" class="login-card__error">
          <span>{{ registerForm.errors.phone }}</span>
        </div>
      </div>

      <!-- 图片验证码 -->
      <div class="login-card__form-item">
        <div class="login-card__input-wrap login-card__input-wrap--code">
          <input
            v-model="registerForm.captchaCode"
            class="login-card__input"
            type="text"
            placeholder="请输入图片验证码"
            maxlength="4"
          />
          <div class="login-card__captcha-image" @click="refreshRegisterCaptcha">
            <img v-if="registerCaptchaUrl" :src="registerCaptchaUrl" alt="captcha" />
            <div v-else class="captcha-placeholder">点击获取</div>
          </div>
        </div>
        <div v-if="registerForm.errors.imageCaptcha" class="login-card__error">
          <span>{{ registerForm.errors.imageCaptcha }}</span>
        </div>
      </div>

      <div class="login-card__form-item">
        <div class="login-card__input-wrap login-card__input-wrap--code">
          <input
            v-model="registerForm.code"
            class="login-card__input"
            type="text"
            placeholder="请输入验证码"
            maxlength="6"
          />
          <button
            class="login-card__code-btn"
            :disabled="countdown > 0"
            @click="handleSendCode"
          >
            {{ countdown > 0 ? `${countdown}s` : '获取验证码' }}
          </button>
        </div>
        <div v-if="registerForm.errors.code" class="login-card__error">
          <span>{{ registerForm.errors.code }}</span>
        </div>
      </div>

      <div class="login-card__form-item">
        <div class="login-card__input-wrap">
          <img class="login-card__input-icon login-card__input-icon--lock" src="./assets/img/FigmaDDSSlicePNGa25834c98b83a5353b3241915865c83f.png" alt="lock" />
          <div class="login-card__input-divider"></div>
          <input
            v-model="registerForm.password"
            class="login-card__input"
            type="password"
            placeholder="请设置登录密码"
          />
        </div>
        <div class="login-card__password-hint">密码长度必须大于8位，并且是复杂密码（包含大小写字母、数字、特殊符号中的至少 2 种）</div>
      </div>

      <div class="login-card__form-item">
        <div class="login-card__input-wrap">
          <img class="login-card__input-icon login-card__input-icon--lock" src="./assets/img/FigmaDDSSlicePNGa25834c98b83a5353b3241915865c83f.png" alt="lock" />
          <div class="login-card__input-divider"></div>
          <input
            v-model="registerForm.confirmPassword"
            class="login-card__input"
            type="password"
            placeholder="请再次输入登录密码"
          />
        </div>
      </div>

      <div class="login-card__form-item">
        <div class="login-card__input-wrap">
          <input
            v-model="registerForm.lastName"
            @input="handleRegisterNameInput"
            class="login-card__input"
            type="text"
            :placeholder="accountType === 'personal' ? '账号昵称（最多 20 字符）' : '企业名称'"
          />
        </div>
        <div v-if="registerForm.errors.lastName" class="login-card__error">
          <span>{{ registerForm.errors.lastName }}</span>
        </div>
      </div>

      <div class="login-card__agree-row">
        <div 
          class="login-card__agree-box" 
          :class="{ 'login-card__agree-box--checked': registerForm.agreed }"
          @click="registerForm.agreed = !registerForm.agreed"
        >
          <div class="login-card__agree-inner" v-if="registerForm.agreed"></div>
        </div>
        <span class="login-card__agree-text">
          我已阅读并同意
          <a href="/user-agreement" target="_blank" class="agree-link">《用户协议》</a>
          和
          <a href="/privacy-terms" target="_blank" class="agree-link">《隐私政策》</a>
        </span>
      </div>

      <button class="login-card__submit" @click="handleRegister">
        <span>注 册</span>
      </button>
    </div>

    <!-- 忘记密码表单 -->
    <div v-show="view === 'forgot'" class="login-card__form">
      <div class="login-card__form-title">{{ accountType === 'company' ? '企业忘记密码' : '个人忘记密码' }}</div>

      <div class="login-card__form-item">
        <div class="login-card__input-wrap">
          <img class="login-card__input-icon login-card__input-icon--phone" src="./assets/img/FigmaDDSSlicePNG5aefd021dfa26ee89db1bfbb808c4104.png" alt="phone" />
          <div class="login-card__input-divider"></div>
          <input
            v-model="forgotForm.mobile"
            class="login-card__input"
            type="text"
            placeholder="请输入注册手机号"
            maxlength="11"
          />
        </div>
        <div v-if="forgotForm.errors.mobile" class="login-card__error">
          <span>{{ forgotForm.errors.mobile }}</span>
        </div>
      </div>

      <!-- 图片验证码 -->
      <div class="login-card__form-item">
        <div class="login-card__input-wrap login-card__input-wrap--code">
          <input
            v-model="forgotForm.captchaCode"
            class="login-card__input"
            type="text"
            placeholder="请输入图片验证码"
            maxlength="4"
          />
          <div class="login-card__captcha-image" @click="refreshForgotCaptcha">
            <img v-if="forgotCaptchaUrl" :src="forgotCaptchaUrl" alt="captcha" />
            <div v-else class="captcha-placeholder">点击获取</div>
          </div>
        </div>
        <div v-if="forgotForm.errors.imageCaptcha" class="login-card__error">
          <span>{{ forgotForm.errors.imageCaptcha }}</span>
        </div>
      </div>

      <div class="login-card__form-item">
        <div class="login-card__input-wrap login-card__input-wrap--code">
          <input
            v-model="forgotForm.code"
            class="login-card__input"
            type="text"
            placeholder="请输入短信验证码"
            maxlength="6"
          />
          <button
            class="login-card__code-btn"
            :disabled="countdown > 0"
            @click="handleSendCode"
          >
            {{ countdown > 0 ? `${countdown}s` : '获取验证码' }}
          </button>
        </div>
        <div v-if="forgotForm.errors.code" class="login-card__error">
          <span>{{ forgotForm.errors.code }}</span>
        </div>
      </div>

      <div class="login-card__form-item">
        <div class="login-card__input-wrap">
          <img class="login-card__input-icon login-card__input-icon--lock" src="./assets/img/FigmaDDSSlicePNGa25834c98b83a5353b3241915865c83f.png" alt="lock" />
          <div class="login-card__input-divider"></div>
          <input
            v-model="forgotForm.password"
            class="login-card__input"
            type="password"
            placeholder="请输入新的登录密码"
          />
        </div>
        <div class="login-card__password-hint">密码长度必须大于8位，并且是复杂密码（包含大小写字母、数字、特殊符号中的至少 2 种）</div>
      </div>

      <div class="login-card__form-item">
        <div class="login-card__input-wrap">
          <img class="login-card__input-icon login-card__input-icon--lock" src="./assets/img/FigmaDDSSlicePNGa25834c98b83a5353b3241915865c83f.png" alt="lock" />
          <div class="login-card__input-divider"></div>
          <input
            v-model="forgotForm.confirmPassword"
            class="login-card__input"
            type="password"
            placeholder="请再次输入登录密码"
          />
        </div>
      </div>

      <button class="login-card__submit" @click="handleForgotSubmit">
        <span>提 交</span>
      </button>

      <div class="login-card__back" @click="switchView('login')">返回登录</div>
    </div>

    <!-- 注册成功 -->
    <div v-show="view === 'success'" class="login-card__success">
      <div class="login-card__success-icon">
        <svg viewBox="0 0 100 100" width="80" height="80">
          <circle cx="50" cy="50" r="44" fill="none" stroke="#7dcfa0" stroke-width="8"/>
          <polyline points="28,52 43,67 72,36" fill="none" stroke="#7dcfa0" stroke-width="8" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="login-card__success-title">恭喜您，注册成功</div>
      <div class="login-card__success-sub">{{ redirectCountdown }}S后自动跳转</div>
      <button class="login-card__submit" @click="goProfile">
        {{ accountType === 'personal' ? '完善个人资料' : '快去完善企业资料，发布资讯' }}
      </button>
    </div>

    <!-- 第三方登录 -->
    <div class="login-card__third-party" v-if="(view === 'login' || view === 'register') && accountType === 'personal'">
      <span class="login-card__third-party-text">使用第三方帐号注册/登录</span>
      <div class="login-card__third-party-icons">
        <div class="login-card__third-party-icon" title="微信" @click="initWechatLogin">
          <img src="./assets/img/FigmaDDSSlicePNG2c9380c773cf63535c5063ce8f2c4301.png" alt="wechat" />
        </div>
        <div class="login-card__third-party-icon" title="QQ">
          <img src="./assets/img/FigmaDDSSlicePNG1fb59261081f1dea5b86c899b4d1036d.png" alt="qq" />
        </div>
        <!-- <div class="login-card__third-party-icon" title="支付宝" @click="initAlipayLogin">
          <img src="./assets/img/FigmaDDSSlicePNG565fd567860c82d8fc045326a2cce7be.png" alt="alipay" />
        </div> -->
      </div>
    </div>

    <!-- 微信登录新窗口弹窗 -->
    <transition name="mag-dialog-fade">
      <div v-if="showIframeDialog" class="wechat-new-window-dialog" @click.self="showIframeDialog = false">
        <div class="wechat-new-window-content">
          <div class="wechat-close-btn" @click="closeWechatWindow">
            <span>✕</span>
          </div>
          <div class="wechat-window-hint">
            <p>请在弹出窗口中完成微信授权</p>
            <p>如未自动弹出，请检查浏览器地址栏的弹窗拦截提示</p>
          </div>
        </div>
      </div>
    </transition>

    <!-- 绑定手机号弹窗：仅点击右上角关闭按钮才会关闭 -->
    <transition name="mag-dialog-fade">
    <div v-if="bindingDialogVisible" class="wechat-binding-dialog">
      <div class="wechat-binding-content">
        <!-- 关闭按钮 -->
        <div class="binding-close-btn" @click="closeBindingDialog">
          <span>✕</span>
        </div>

        <h3 class="binding-title">为了您的账号安全，请先绑定手机号</h3>

        <!-- 接口错误提示（接口返回的错误信息在弹窗内直接展示） -->
        <div v-if="bindingApiError" class="binding-api-error">
          <span>{{ bindingApiError }}</span>
        </div>
        
        <!-- 手机号输入 -->
        <div class="binding-input-row">
          <input
            v-model="bindingForm.mobile"
            class="binding-mobile-input"
            type="tel"
            placeholder="请输入手机号"
            maxlength="11"
            style="display: block; width: 100%;"
          />
        </div>
        <div v-if="bindingForm.errors.mobile" class="binding-error">
          <span>{{ bindingForm.errors.mobile }}</span>
        </div>
        
        <!-- 图片验证码 -->
        <div class="binding-captcha-row">
          <input
            v-model="bindingForm.captchaCode"
            class="binding-captcha-input"
            type="text"
            placeholder="请输入图片验证码"
            maxlength="4"
          />
          <div class="binding-captcha-image" @click="refreshBindingCaptcha">
            <img v-if="bindingCaptchaUrl" :src="bindingCaptchaUrl" alt="captcha" />
            <div v-else class="captcha-placeholder">点击获取</div>
          </div>
        </div>
        <div v-if="bindingForm.errors.imageCaptcha" class="binding-error">
          <span>{{ bindingForm.errors.imageCaptcha }}</span>
        </div>
        
        <!-- 短信验证码 -->
        <div class="binding-sms-row">
          <input
            v-model="bindingForm.code"
            class="binding-sms-input"
            type="text"
            placeholder="请输入短信验证码"
            maxlength="6"
          />
          <button
            class="binding-sms-btn"
            :disabled="bindingCountdown > 0 || bindingSending"
            @click="handleSendBindingCode"
          >
            {{ bindingCountdown > 0 ? `${bindingCountdown}s` : (bindingSending ? '发送中...' : '获取验证码') }}
          </button>
        </div>
        <div v-if="bindingForm.errors.code" class="binding-error">
          <span>{{ bindingForm.errors.code }}</span>
        </div>
        
        <!-- 同意协议 -->
        <div class="binding-agree-row" @click="bindingForm.agreed = !bindingForm.agreed">
          <div class="binding-checkbox" :class="{ 'is-checked': bindingForm.agreed }">
            <div class="binding-checkbox-inner" v-if="bindingForm.agreed"></div>
          </div>
         <span class="login-card__agree-text">
          我已阅读并同意
          <a href="/user-agreement" target="_blank" class="agree-link">《用户协议》</a>
          和
          <a href="/privacy-terms" target="_blank" class="agree-link">《隐私政策》</a>
        </span>
        </div>
        
        <!-- 操作按钮 -->
        <div class="binding-button-row">
          <button class="binding-cancel-btn" @click="handleCancelBinding">
            取 消
          </button>
          <button
            class="binding-submit-btn"
            :disabled="bindingSubmitting"
            @click="submitBinding"
          >
            {{ bindingSubmitting ? '提交中...' : '提 交' }}
          </button>
        </div>
      </div>
    </div>
  </transition>
  </div>
</template>

<script>
import { Toast } from 'vant'
import {
  memberLogin,
  companyLogin,
  memberRegister,
  companyRegister,
  memberGetMessage,
  companyGetMessage,
  getCaptchaImage,
  memberForgotPassword,
  companyForgotPassword
} from '../../api'
import CryptoJS from 'crypto-js'
import { request } from '../../api/request'

// ⚠️ 密钥必须与后端完全一致（16 字节）
const SECRET_KEY = 'zp_base_aes_2026'

export default {
  name: 'LoginCard',
  props: {
    modalMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // AES 加密密钥（必须与 Java 后端的 KEY 完全一致）
      SECRET_KEY: 'zp_base_aes_2026',
      
      accountType: 'personal', // personal | company
      view: 'login',           // login | register | forgot | success
      showPassword: false,
      // 微信登录相关
      wechatGuid: '',
      showIframeDialog: false,
      // 支付宝登录相关
      alipayGuid: '',
      bindingDialogVisible: false,
      bindingForm: {
        mobile: '',
        code: '',
        agreed: false,
        captchaCode: '',
        uuid: '',
        errors: { mobile: '', code: '', imageCaptcha: '' }
      },
      bindingCaptchaUrl: '',
      bindingCountdown: 0,      // 绑定弹窗独立的短信倒计时
      bindingTimer: null,
      bindingSending: false,    // 是否正在发送绑定短信
      bindingSubmitting: false, // 是否正在提交绑定
      bindingApiError: '',      // 绑定弹窗内展示的接口错误信息
      countdown: 0,
      timer: null,
      redirectCountdown: 5,
      redirectTimer: null,
      loginForm: {
        phone: '',
        password: '',
        autoLogin: false,
        captchaCode: '',         // 验证码输入
        uuid: '',                // 验证码 UUID
        agreed: false,            // 协议勾选
        errors: { phone: '', password: '', captcha: '' }
      },
      loginError: '',
      registerForm: {
        phone: '',
        code: '',
        password: '',
        confirmPassword: '',
        lastName: '',
        agreed: false,            // 默认不勾选
        uuid: '',                  // 验证码 UUID
        captchaCode: '',           // 图片验证码
        errors: { phone: '', code: '', lastName: '' }
      },
      forgotForm: {
        mobile: '',
        code: '',
        password: '',
        confirmPassword: '',
        uuid: '',                  // 验证码 UUID
        captchaCode: '',           // 图片验证码
        errors: { mobile: '', code: '' }
      },
      captchaUrl: '',           // 登录验证码图片 URL
      registerCaptchaUrl: '',   // 注册验证码图片 URL
      forgotCaptchaUrl: '',     // 忘记密码验证码图片 URL
      uuid: ''                  // 验证码 UUID
    }
  },
  beforeDestroy() {
    this.clearTimers()
  },
  mounted() {
    // 页面加载时根据当前视图自动加载对应的验证码
    this.loadInitialCaptcha()
  },
  methods: {
    // 初始化加载验证码
    loadInitialCaptcha() {
      if (this.view === 'login') {
        this.loadCaptcha()
      } else if (this.view === 'register') {
        this.loadRegisterCaptcha()
      } else if (this.view === 'forgot') {
        this.loadForgotCaptcha()
      }
    },
    switchAccountType(type) {
      this.accountType = type
    },
    switchView(view) {
      this.view = view
      this.loginError = ''
      this.loginForm.errors = { phone: '', password: '', captcha: '' }
      this.registerForm.errors = { phone: '', code: '', lastName: '', imageCaptcha: '' }
      this.forgotForm.errors = { mobile: '', code: '', imageCaptcha: '' }
      // 切换视图时重新加载验证码
      if (view === 'register') {
        this.loadRegisterCaptcha()
        // 清空昵称并移除特殊字符
        this.registerForm.lastName = this.registerForm.lastName.replace(/[^一 -\u9fa5a-zA-Z0-9]/g, '')
      } else if (view === 'forgot') {
        this.loadForgotCaptcha()
      }
    },
    clearTimers() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      if (this.redirectTimer) {
        clearInterval(this.redirectTimer)
        this.redirectTimer = null
      }
      if (this.bindingTimer) {
        clearInterval(this.bindingTimer)
        this.bindingTimer = null
      }
    },
    /**
     * AES-ECB-PKCS5Padding 加密方法
     * @param {string} text - 明文文本
     * @returns {string} Base64 编码后的密文
     */
    encryptPassword(text) {
      try {
        // 将字符串转换为 UTF-8 字节数组
        const wordArray = CryptoJS.enc.Utf8.parse(text);
        
        // 使用 ECB 模式和 PKCS7 填充
        const key = CryptoJS.enc.Utf8.parse(SECRET_KEY)
        const encrypted = CryptoJS.AES.encrypt(wordArray, key, {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7
        })
        
        // 返回 Base64 编码的密文
        return encrypted.toString()
      } catch (error) {
        console.error('加密失败:', error)
        throw new Error('密码加密失败')
      }
    },
    // 按字符权重截断字符串（英文数字占 1，汉字占 2）
    limitCharLength(str, maxLen) {
      if (!str) return str
      let len = 0
      let i = 0
      for (; i < str.length; i++) {
        const charLen = str.charCodeAt(i) > 127 ? 2 : 1
        if (len + charLen > maxLen) break
        len += charLen
      }
      return str.substring(0, i)
    },
    startRedirectCountdown() {
      this.redirectCountdown = 5
      const defaultPath = this.accountType === 'personal' ? '/my' : '/my'
      const redirect = this.$route.query.redirect
      const targetPath = redirect || defaultPath
      this.redirectTimer = setInterval(() => {
        this.redirectCountdown--
        if (this.redirectCountdown <= 0) {
          clearInterval(this.redirectTimer)
          this.redirectTimer = null
          this.$router.push(targetPath)
        }
      }, 1000)
    },
    // 发送短信验证码
    async handleSendCode() {
      if (this.countdown > 0) return

      const isRegister = this.view === 'register'
      const phone = isRegister ? this.registerForm.phone : this.forgotForm.mobile
      const errorField = isRegister ? 'registerForm' : 'forgotForm'
      const errorKey = isRegister ? 'phone' : 'mobile'

      if (!phone || !/^1[3-9]\d{9}$/.test(phone)) {
        this[errorField].errors[errorKey] = '请输入正确的手机号'
        return
      }
      this[errorField].errors[errorKey] = ''

      try {
        const api = this.accountType === 'personal' ? memberGetMessage : companyGetMessage
        // 根据当前视图获取对应的 UUID 和图片验证码
        let captchaData = {}
        if (this.view === 'register') {
          captchaData = {
            uuid: this.registerForm.uuid,
            captchaCode: this.registerForm.captchaCode
          }
        } else if (this.view === 'forgot') {
          captchaData = {
            uuid: this.forgotForm.uuid,
            captchaCode: this.forgotForm.captchaCode
          }
        }
        await api({ 
          areaCode: '86', 
          mobile: phone, 
          messageType: this.view === 'register' ? 1 : 3,
          ...captchaData 
        })
        this.startCountdown()
        if (this.view === 'register') {
          this.loadRegisterCaptcha()
        } else if (this.view === 'forgot') {
          this.loadForgotCaptcha()
        }
      } catch (e) {
         if (this.view === 'register') {
          this.loadRegisterCaptcha()
        } else if (this.view === 'forgot') {
          this.loadForgotCaptcha()
        }
        Toast(this.getErrorMsg(e, '验证码发送失败，请稍后重试'))
      }
    },
    
    // 处理注册表单名称输入（账号昵称）
    handleRegisterNameInput() {
      const val = this.registerForm.lastName
      // 移除特殊字符（保留字母、数字、汉字）
      const cleaned = val.replace(/[^a-zA-Z0-9\u4e00-\u9fa5]/g, '')
      // 长度限制：最多 20 个字符（按权重计算，英文数字占 1，汉字占 2）
      this.registerForm.lastName = this.limitCharLength(cleaned, 20)
      // 清空错误信息
      if (this.registerForm.errors.lastName) {
        this.registerForm.errors.lastName = ''
      }
    },
    startCountdown() {
      this.countdown = 60
      this.timer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          clearInterval(this.timer)
          this.timer = null
        }
      }, 1000)
    },
    
    /** 验证昵称格式（只允许大小写字母、数字、汉字）*/
    validateNicknameFormat(nickname) {
      const reg = /^[a-zA-Z0-9\u4e00-\u9fa5]+$/
      return reg.test(nickname)
    },
    
    // 加载验证码图片
    async loadCaptcha() {
      try {
        const res = await getCaptchaImage()
        console.log('验证码接口返回:', res)
        if (res.code === 200) {
          this.uuid = res.uuid || ''
          this.captchaUrl = `data:image/png;base64,${res.img}`
          // 同时存储到登录表单
          this.loginForm.uuid = res.uuid || ''
        }
      } catch (e) {
        console.error('验证码加载失败', e)
      }
    },
    // 加载注册验证码
    async loadRegisterCaptcha() {
      try {
        const res = await getCaptchaImage()
        if (res.code === 200) {
          this.registerForm.uuid = res.uuid || ''
          this.registerCaptchaUrl = `data:image/png;base64,${res.img}`
        }
      } catch (e) {
        console.error('注册验证码加载失败', e)
      }
    },
    // 加载忘记密码验证码
    async loadForgotCaptcha() {
      try {
        const res = await getCaptchaImage()
        if (res.code === 200) {
          this.forgotForm.uuid = res.uuid || ''
          this.forgotCaptchaUrl = `data:image/png;base64,${res.img}`
        }
      } catch (e) {
        console.error('忘记密码验证码加载失败', e)
      }
    },
    // 点击刷新验证码
    refreshCaptcha() {
      this.loadCaptcha()
    },
    // 点击刷新注册验证码
    refreshRegisterCaptcha() {
      this.loadRegisterCaptcha()
    },
    // 点击刷新忘记密码验证码
    refreshForgotCaptcha() {
      this.loadForgotCaptcha()
    },
    // 登录
    async handleLogin() {
      this.loginError = ''
      this.loginForm.errors = { phone: '', password: '', captcha: '' }
      
      // 检查是否已同意协议
      if (!this.loginForm.agreed) {
        Toast('请先阅读并同意《用户协议》和《隐私政策》')
        return
      }
      if (!this.loginForm.phone) {
        this.loginForm.errors.phone = '请输入手机号'
        return
      }
      if (!/^1[3-9]\d{9}$/.test(this.loginForm.phone)) {
        this.loginForm.errors.phone = '请输入正确的手机号'
        return
      }
      if (!this.loginForm.password) {
        this.loginForm.errors.password = '请输入登录密码'
        return
      }
      // 验证码验证
      if (!this.loginForm.captchaCode) {
        this.loginForm.errors.captcha = '请输入验证码'
        return
      }


      // 对密码进行 AES 加密
      let encryptedPassword
      try {
        encryptedPassword = this.encryptPassword(this.loginForm.password)
      } catch (e) {
        this.loginForm.errors.password = '密码加密失败，请重试'
        Toast('密码加密失败，请重试')
        return
      }

      const params = {
        loginName: this.loginForm.phone,
        password: encryptedPassword,
        loginType: 1,
        uuid: this.loginForm.uuid,
        captchaCode: this.loginForm.captchaCode
      }

      try {
        const res = this.accountType === 'personal'
          ? await memberLogin(params)
          : await companyLogin(params)

        const data = res.data || {}
        localStorage.setItem('token', data.token || '')
        localStorage.setItem('userType', this.accountType)
        localStorage.setItem('userInfo', JSON.stringify(data))

        if (this.modalMode) {
          this.$emit('login-success')
        } else {
          const targetPath = this.accountType === 'personal' ? '/my' : '/my'
          const redirect = this.$route.query.redirect
          this.$router.push(redirect || targetPath)
        }
      } catch (e) {
        const msg = this.getErrorMsg(e, '登录失败')
        this.loginError = msg
        this.refreshCaptcha()
        Toast(msg)
      }
    },
    // 注册
    async handleRegister() {
      this.registerForm.errors = { phone: '', code: '', lastName: '', imageCaptcha: '' }
      
      // 检查是否已同意协议
      if (!this.registerForm.agreed) {
        Toast('请先阅读并同意《用户协议》和《隐私政策》')
        return
      }
      if (!this.registerForm.phone) {
        this.registerForm.errors.phone = '请输入手机号'
        return
      }
      if (!/^1[3-9]\d{9}$/.test(this.registerForm.phone)) {
        this.registerForm.errors.phone = '请输入正确的手机号'
        return
      }
      // 图片验证码验证
      if (!this.registerForm.captchaCode) {
        this.registerForm.errors.imageCaptcha = '请输入图片验证码'
        return
      }
      if (!this.registerForm.code) {
        this.registerForm.errors.code = '请输入验证码'
        return
      }
      if (!this.registerForm.password) {
        this.registerForm.errors.code = '请输入登录密码'
        return
      }
      // 新密码验证：长度 8-20 位，且至少包含两种字符类型 (大小写字母、数字、特殊符号)
      if (!this.registerForm.password) {
        this.registerForm.errors.code = '请输入登录密码'
        return
      }
      if (this.registerForm.password.length < 8 || this.registerForm.password.length > 20) {
        this.registerForm.errors.code = '密码长度必须在 8-20 个字符之间'
        return
      }
      
      // 检查密码复杂度
      const hasUpper = /[A-Z]/.test(this.registerForm.password)
      const hasLower = /[a-z]/.test(this.registerForm.password)
      const hasDigit = /\d/.test(this.registerForm.password)
      const hasSpecial = /[!@#$%^&*()_+=][{};':"\\|,.<>?~`-]/.test(this.registerForm.password)
      
      const typeCount = [hasUpper, hasLower, hasDigit, hasSpecial].filter(Boolean).length
      
      if (typeCount < 2) {
        this.registerForm.errors.code = '密码必须是复杂密码（包含大小写字母、数字、特殊符号中的至少 2 种）'
        return
      }
      if (!this.registerForm.confirmPassword) {
        this.registerForm.errors.code = '请再次输入密码'
        return
      }
      if (this.registerForm.password !== this.registerForm.confirmPassword) {
        this.registerForm.errors.code = '两次密码输入不一致'
        return
      }
      if (!this.registerForm.lastName) {
        this.registerForm.errors.lastName = this.accountType === 'personal' ? '请输入账号昵称' : '请输入企业名称'
        return
      }
      // 验证昵称格式（只允许大小写字母、数字、汉字）
      if (!this.validateNicknameFormat(this.registerForm.lastName)) {
        this.registerForm.errors.lastName = '昵称只能包含大小写字母、数字和汉字'
        return
      }
      // 去除昵称中的特殊字符和空格
      this.registerForm.lastName = this.registerForm.lastName.trim().replace(/[^a-zA-Z0-9\u4e00-\u9fa5]/g, '')
      // 昵称不能超过 20 个字符（按权重计算）
      this.registerForm.lastName = this.limitCharLength(this.registerForm.lastName, 20)
      if (!this.registerForm.lastName) {
        this.registerForm.errors.lastName = '请输入账号昵称'
        return
      }
      if (!this.registerForm.agreed) {
        Toast('请同意相关规定', 'warning')
        return
      }

      try {
        let res
        if (this.accountType === 'personal') {
          // 对密码进行 AES 加密
          let encryptedPassword
          try {
            encryptedPassword = this.encryptPassword(this.registerForm.password)
          } catch (e) {
            this.registerForm.errors.code = '密码加密失败，请稍后重试'
            Toast('密码加密失败，请稍后重试')
            return
          }

          res = await memberRegister({
            mobile: this.registerForm.phone,
            smsCode: this.registerForm.code,
            password: encryptedPassword,
            nickname: this.registerForm.lastName,
            uuid: this.registerForm.uuid,
            captchaCode: this.registerForm.captchaCode
          })
        } else {
          // 对密码进行 AES 加密
          let encryptedPassword
          try {
            encryptedPassword = this.encryptPassword(this.registerForm.password)
          } catch (e) {
            this.registerForm.errors.code = '密码加密失败，请稍后重试'
            Toast('密码加密失败，请稍后重试')
            return
          }

          res = await companyRegister({
            companyName: this.registerForm.lastName,
            loginName: this.registerForm.phone,
            password: encryptedPassword,
            smsCode: this.registerForm.code,
            uuid: this.registerForm.uuid,
            captchaCode: this.registerForm.captchaCode
          })
        }

        const data = (res && res.data) || {}
        if (data.token) {
          localStorage.setItem('token', data.token)
        }
        localStorage.setItem('userType', this.accountType)
        if (data.userInfo) {
          localStorage.setItem('userInfo', JSON.stringify(data.userInfo))
        }

        if (this.modalMode) {
          this.$emit('login-success')
        } else {
          // 成功之后清空表单内容
          this.registerForm.phone = ''
          this.registerForm.code = ''
          this.registerForm.password = ''
          this.registerForm.confirmPassword = ''
          this.registerForm.lastName = ''
          this.registerForm.uuid = ''
          this.registerForm.captchaCode = ''
          this.registerCaptchaUrl = ''
          this.view = 'success'
          this.startRedirectCountdown()
        }
      } catch (e) {
        const msg = this.getErrorMsg(e, '注册失败，请稍后重试')
        this.registerForm.errors.code = msg
        Toast(msg)
      }
    },
    // 忘记密码提交
    async handleForgotSubmit() {
      this.forgotForm.errors = { mobile: '', code: '', imageCaptcha: '' }
      if (!this.forgotForm.mobile) {
        this.forgotForm.errors.mobile = '请输入手机号'
        return
      }
      if (!/^1[3-9]\d{9}$/.test(this.forgotForm.mobile)) {
        this.forgotForm.errors.mobile = '请输入正确的手机号'
        return
      }
      // 图片验证码验证
      if (!this.forgotForm.captchaCode) {
        this.forgotForm.errors.imageCaptcha = '请输入图片验证码'
        return
      }
      if (!this.forgotForm.code) {
        this.forgotForm.errors.code = '请输入短信验证码'
        return
      }
      if (!this.forgotForm.password) {
        this.forgotForm.errors.code = '请输入新密码'
        return
      }
      // 新密码验证：长度 8-20 位，且至少包含两种字符类型 (大小写字母、数字、特殊符号)
      if (!this.forgotForm.password) {
        this.forgotForm.errors.code = '请输入新密码'
        return
      }
      if (this.forgotForm.password.length < 8 || this.forgotForm.password.length > 20) {
        this.forgotForm.errors.code = '密码长度必须在 8-20 个字符之间'
        return
      }
      
      // 检查密码复杂度
      const hasUpper = /[A-Z]/.test(this.forgotForm.password)
      const hasLower = /[a-z]/.test(this.forgotForm.password)
      const hasDigit = /\d/.test(this.forgotForm.password)
      const hasSpecial = /[!@#$%^&*()_+=][{};':"\\|,.<>?~`-]/.test(this.forgotForm.password)
      
      const typeCount = [hasUpper, hasLower, hasDigit, hasSpecial].filter(Boolean).length
      
      if (typeCount < 2) {
        this.forgotForm.errors.code = '密码必须是复杂密码（包含大小写字母、数字、特殊符号中的至少 2 种）'
        return
      }
      if (this.forgotForm.password !== this.forgotForm.confirmPassword) {
        this.forgotForm.errors.code = '两次密码输入不一致'
        return
      }

      try {
        // 对密码进行 AES 加密
        let encryptedPassword
        try {
          encryptedPassword = this.encryptPassword(this.forgotForm.password)
        } catch (e) {
          this.forgotForm.errors.code = '密码加密失败，请稍后重试'
          Toast('密码加密失败，请稍后重试')
          return
        }

        // 根据账号类型调用不同接口
        const params = {
          mobile: this.forgotForm.mobile,
          smsCode: this.forgotForm.code,
          password: encryptedPassword
        }

        if (this.accountType === 'personal') {
          await memberForgotPassword(params)
        } else {
          await companyForgotPassword(params)
        }

        Toast('密码修改成功！')
        // 清空表单内容
        this.forgotForm.mobile = ''
        this.forgotForm.code = ''
        this.forgotForm.password = ''
        this.forgotForm.confirmPassword = ''
        this.forgotForm.uuid = ''
        this.forgotForm.captchaCode = ''
        this.forgotCaptchaUrl = ''
        this.view = 'login'
      } catch (e) {
        const msg = this.getErrorMsg(e, '密码修改失败')
        this.forgotForm.errors.code = msg
        Toast(msg)
      }
    },
    goProfile() {
      this.clearTimers()
      if (this.modalMode) {
        this.$emit('login-success')
        return
      }
      const defaultPath = this.accountType === 'personal' ? '/my' : '/my'
      // const redirect = this.$route.query.redirect
      this.$router.push(defaultPath)
    },
    getErrorMsg(e, defaultMsg) {
      if (!e) return defaultMsg
      if (e.response && e.response.data) {
        const data = e.response.data
        if (typeof data === 'string') return data
        return data.msg || data.message || defaultMsg
      }
      return e.message || defaultMsg
    },
    // ==================== 微信登录相关 ====================
    // 初始化微信登录
    initWechatLogin() {
      // 生成 GUID
      this.wechatGuid = this.generateGuid()
      console.log('生成的 GUID:', this.wechatGuid)
      
      // 打开新窗口进行微信授权
      const windowWidth = 800
      const windowHeight = 400
      const left = (screen.width - windowWidth) / 2
      const top = (screen.height - windowHeight) / 2
      const features = `width=${windowWidth},height=${windowHeight},left=${left},top=${top}`
      const BASE_URL = process.env.VUE_APP_BASE_URL || 'https://api.main.cbrand.com.cn'
      const newWindow = window.open(
        `${BASE_URL}/api/oauth/login/WECHAT_OPEN/${this.wechatGuid}`,
        '_blank',
        features
      )
      
      if (!newWindow) {
        Toast('请允许浏览器弹窗以完成微信授权')
        return
      }
      
      // GUID 注册成功，显示引导弹窗
      request(`/api/oauth/cache/member/${this.wechatGuid}`)
        .then(res => {
          if (res.code === 200) {
            // GUID 注册成功，显示弹窗提示用户
            this.showIframeDialog = true
            // 启动轮询检查登录状态
            this.startPollingStatus(newWindow)
          } else {
            Toast('GUID 注册失败')
            newWindow.close()
          }
        })
        .catch(err => {
          console.error('GUID 注册失败:', err)
          Toast('网络错误')
          newWindow.close()
        })
    },
    // ==================== 支付宝登录相关 ====================
    // 初始化支付宝登录
    async initAlipayLogin() {
      // 生成 GUID
      this.alipayGuid = this.generateGuid()
      console.log('生成的 GUID:', this.alipayGuid)
      
      // 打开新窗口进行支付宝授权
      const windowWidth = 800
      const windowHeight = 400
      const left = (screen.width - windowWidth) / 2
      const top = (screen.height - windowHeight) / 2
      const features = `width=${windowWidth},height=${windowHeight},left=${left},top=${top}`
      const BASE_URL = process.env.VUE_APP_BASE_URL || 'https://api.main.cbrand.com.cn'
      const newWindow = window.open(
        `${BASE_URL}/api/oauth/login/ALIPAY/${this.alipayGuid}`,
        '_blank',
        features
      )
      
      if (!newWindow) {
        Toast('请允许浏览器弹窗以完成支付宝授权')
        return
      }
      
      // GUID 注册成功，显示引导弹窗
      request(`/api/oauth/cache/member/${this.alipayGuid}`)
        .then(res => {
          if (res.code === 200) {
            // GUID 注册成功，显示弹窗提示用户
            this.showIframeDialog = true
            // 启动轮询检查登录状态
            this.startPollingStatusForAlipay(newWindow)
          } else {
            Toast('GUID 注册失败')
            newWindow.close()
          }
        })
        .catch(err => {
          console.error('GUID 注册失败:', err)
          Toast('网络错误')
          newWindow.close()
        })
    },
    generateGuid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0
        const v = c === 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16).toUpperCase()
      })
    },
    // 开始轮询登录状态
    startPollingStatus(newWindow) {
      if (this.timer) clearInterval(this.timer)
      
      this.timer = setInterval(async () => {
        try {
          const res = await request(`/api/oauth/getCache/${this.wechatGuid}`)
          console.log('轮询登录状态:', res)
          if (res.code === 200 && res.data) {
            const status = res.data.status
            console.log('当前登录状态:', status)
            
            if (status === 1) {
              // 登录成功
              clearInterval(this.timer)
              this.timer = null
              this.showIframeDialog = false
              if (newWindow && !newWindow.closed) {
                newWindow.close()
              }
              this.handleWechatLoginSuccess(res.data.loginData)
            } else if (status === 2) {
              // 登录未绑定账号
              clearInterval(this.timer)
              this.timer = null
              this.showIframeDialog = false
              if (newWindow && !newWindow.closed) {
                newWindow.close()
              }
              this.openBindingDialog()
            }
          }
        } catch (error) {
          console.error('轮询失败:', error)
        }
      }, 1000)
    },
    // 处理微信登录成功
    handleWechatLoginSuccess(loginData) {
      console.log('微信登录成功数据:', loginData)
      
      // 保存用户信息到 localStorage
      if (loginData.token) {
        localStorage.setItem('token', loginData.token)
      }
      if (loginData.userId) {
        localStorage.setItem('userId', loginData.userId)
      }
      if (loginData.nickname) {
        localStorage.setItem('nickname', loginData.nickname)
      }
      if (loginData.avatar) {
        localStorage.setItem('avatar', loginData.avatar)
      }
      if (loginData.mobile) {
        localStorage.setItem('mobile', loginData.mobile)
      }
      localStorage.setItem('userType', this.accountType)
      // 跳转到个人中心
    
       if (this.modalMode) {
          this.$emit('login-success')
        } else {
           this.$router.push('/my')
        }
    },
    // 打开绑定手机对话框（微信登录用）
    openBindingDialog() {
      // 使用微信的 GUID
      this.bindingForm.uuid = this.wechatGuid
      this.resetBindingDialog()
      // 加载图片验证码，传递已设置的 uuid
      this.loadBindingCaptcha(this.wechatGuid)
      this.bindingDialogVisible = true
    },
    // 打开绑定手机对话框（支付宝登录用）
    openBindingDialogForAlipay() {
      console.log('支付宝授权取消，打开绑定手机窗口')
      // 使用支付宝的 GUID
      this.bindingForm.uuid = this.alipayGuid
      this.resetBindingDialog()
      // 加载图片验证码，传递已设置的 uuid
      this.loadBindingCaptcha(this.alipayGuid)
      this.bindingDialogVisible = true
    },
    // 重置绑定弹窗状态（倒计时、错误提示、发送中标记）
    resetBindingDialog() {
      this.bindingSending = false
      this.bindingSubmitting = false
      if (this.bindingTimer) {
        clearInterval(this.bindingTimer)
        this.bindingTimer = null
      }
      this.bindingCountdown = 0
      this.bindingApiError = ''
      this.bindingForm.errors = { mobile: '', code: '', imageCaptcha: '' }
    },
    // 加载绑定页图片验证码
    loadBindingCaptcha(uuid) {
      const params = { uuid: uuid || '' }
      request('/api/captchaImage', params)
        .then(res => {
          if (res.code === 200) {
            this.bindingCaptchaUrl = `data:image/png;base64,${res.img}`
             this.bindingForm.uuid = res.uuid
            // 只在没有传入 uuid 时才使用后端返回的 uuid
            // if (!uuid) {
            //   this.bindingForm.uuid = res.uuid
            // }
          }
        })
        .catch(err => {
          console.error('获取验证码失败:', err)
        })
    },
    // 刷新绑定页验证码
    refreshBindingCaptcha() {
      this.loadBindingCaptcha(this.bindingForm.uuid)  // 保持现有 uuid
    },
    // 发送绑定页短信验证码
    async handleSendBindingCode() {
      if (this.bindingCountdown > 0 || this.bindingSending) return

      const mobile = (this.bindingForm.mobile || '').trim()
      this.bindingForm.errors = { mobile: '', code: '', imageCaptcha: '' }
      this.bindingApiError = ''

      if (!mobile) {
        this.bindingForm.errors.mobile = '请输入手机号'
        Toast('请输入手机号')
        return
      }
      if (!/^1[3-9]\d{9}$/.test(mobile)) {
        this.bindingForm.errors.mobile = '请输入正确的手机号'
        Toast('请输入正确的手机号')
        return
      }
      if (!this.bindingForm.captchaCode) {
        this.bindingForm.errors.imageCaptcha = '请输入图片验证码'
        Toast('请输入图片验证码')
        return
      }

      this.bindingSending = true
      try {
        await request.post('/api/member/getMessage', {
          areaCode: '86',
          mobile: mobile,
          messageType: 1,
          captchaCode: this.bindingForm.captchaCode,
          uuid: this.bindingForm.uuid
        })

        Toast('验证码已发送')
        this.startBindingCountdown()
       // this.loadBindingCaptcha(this.bindingForm.uuid) // 刷新图片验证码，保持现有 uuid
      } catch (e) {
        this.loadBindingCaptcha(this.bindingForm.uuid) // 刷新图片验证码，保持现有 uuid
        const msg = this.getErrorMsg(e, '验证码发送失败')
        this.bindingApiError = msg
        Toast(msg)
      } finally {
        this.bindingSending = false
      }
    },
    // 绑定弹窗短信倒计时（独立计时，不受其他表单影响）
    startBindingCountdown() {
      if (this.bindingTimer) {
        clearInterval(this.bindingTimer)
      }
      this.bindingCountdown = 60
      this.bindingTimer = setInterval(() => {
        this.bindingCountdown--
        if (this.bindingCountdown <= 0) {
          clearInterval(this.bindingTimer)
          this.bindingTimer = null
        }
      }, 1000)
    },
    // 关闭绑定手机号弹窗（仅通过关闭按钮 / 取消按钮触发）
    closeBindingDialog() {
      this.bindingDialogVisible = false
      this.bindingSending = false
      this.bindingSubmitting = false
      if (this.bindingTimer) {
        clearInterval(this.bindingTimer)
        this.bindingTimer = null
      }
      this.bindingCountdown = 0
      this.bindingApiError = ''
      this.bindingForm.errors = { mobile: '', code: '', imageCaptcha: '' }
    },
    // 提交绑定手机号
    async submitBinding() {
      if (this.bindingSubmitting) return

      this.bindingForm.errors = { mobile: '', code: '', imageCaptcha: '' }
      this.bindingApiError = ''
      
      const mobile = (this.bindingForm.mobile || '').trim()
      if (!mobile || !/^1[3-9]\d{9}$/.test(mobile)) {
        this.bindingForm.errors.mobile = '请输入正确的手机号'
        Toast('请输入正确的手机号')
        return
      }
      
      if (!this.bindingForm.code) {
        this.bindingForm.errors.code = '请输入短信验证码'
        Toast('请输入短信验证码')
        return
      }
      
      if (!this.bindingForm.captchaCode) {
        this.bindingForm.errors.imageCaptcha = '请输入图片验证码'
        Toast('请输入图片验证码')
        return
      }
      
      if (!this.bindingForm.agreed) {
        this.bindingApiError = '请先阅读并同意《用户协议》和《隐私政策》'
        Toast('请先阅读并同意《用户协议》和《隐私政策》')
        return
      }
      
      this.bindingSubmitting = true
      try {
        // 提交绑定手机号时使用正确的 GUID
        const res = await request.post('/api/oauth/binding', {
          mobile: mobile,
          smsCode: this.bindingForm.code,
          uuid: this.wechatGuid ? this.wechatGuid : this.alipayGuid,
          captchaCode: this.bindingForm.captchaCode
        })
        
        if (res && res.data) {
          Toast('绑定成功')
          this.closeBindingDialog()
          // 处理登录成功数据
          this.handleWechatLoginSuccess(res.data)
        } else {
          const msg = (res && (res.msg || res.message)) || '绑定失败，请稍后重试'
          this.bindingApiError = msg
          Toast(msg)
        }
      } catch (e) {
        const msg = this.getErrorMsg(e, '绑定失败')
        this.bindingApiError = msg
        Toast(msg)
      } finally {
        this.bindingSubmitting = false
      }
    },
    // 关闭微信新窗口
    closeWechatWindow() {
      this.showIframeDialog = false
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      // TODO: 尝试关闭新窗口（可能需要通过监听消息）
    },
    // ==================== 支付宝专用轮询和关闭方法 ====================
    // 开始轮询支付宝登录状态（与微信类似但使用不同 GUID）
    startPollingStatusForAlipay(newWindow) {
      if (this.timer) clearInterval(this.timer)
      
      this.timer = setInterval(async () => {
        try {
          const res = await request(`/api/oauth/getCache/${this.alipayGuid}`)
          
          if (res.code === 200 && res.data) {
            const status = res.data.status
            console.log('当前支付宝登录状态:', status)
            
            if (status === 1) {
              // 登录成功
              clearInterval(this.timer)
              this.timer = null
              this.showIframeDialog = false
              if (newWindow && !newWindow.closed) {
                newWindow.close()
              }
              // 获取用户信息并登录
              const loginData = res.data.loginData || {}
              if (loginData.token) {
                localStorage.setItem('token', loginData.token)
              }
              if (loginData.userId) {
                localStorage.setItem('userId', loginData.userId)
              }
              if (loginData.nickname) {
                localStorage.setItem('nickname', loginData.nickname)
              }
              if (loginData.avatar) {
                localStorage.setItem('avatar', loginData.avatar)
              }
              if (loginData.mobile) {
                localStorage.setItem('mobile', loginData.mobile)
              }
              
              Toast('支付宝授权成功')
              // 跳转到个人中心
              if (this.modalMode) {
                this.$emit('login-success')
              } else {
                this.$router.push('/my')
              }
            } else if (status === 0 || status === undefined) {
              // 等待中
              console.log('等待用户授权...')
            } else if (status === 2) {
              // 授权失败或取消
              clearInterval(this.timer)
              this.timer = null
              this.showIframeDialog = false
              if (newWindow && !newWindow.closed) {
                newWindow.close()
              }
              // 打开绑定手机弹窗（与微信登录相同）
              this.openBindingDialogForAlipay()
            }
          }
        } catch (err) {
          console.error('轮询支付宝状态失败:', err)
        }
      }, 1000)  // 每秒检查一次
    },
    // 关闭支付宝新窗口
    closeAlipayWindow() {
      this.showIframeDialog = false
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    // 处理取消绑定
    handleCancelBinding() {
      const result = confirm('确定要取消绑定操作吗？')
      if (result) {
        this.closeBindingDialog()
      }
    }
  }
}
</script>

<style scoped>
/* ========== 卡片容器（毛玻璃效果） ========== */
.login-card {
  position: relative;
  width: 480px;
  padding: 36px 48px 40px;
  background: url('./assets/img/bg_login_card.png') center center / 100% 100% no-repeat;
  border-radius: 24px;
  box-shadow: 0 8px 32px rgba(35, 140, 200, 0.12);
  box-sizing: border-box;
  font-family: 'PingFang SC', 'Microsoft YaHei', 'Helvetica Neue', Arial, sans-serif;
}

/* ========== 弹窗关闭按钮 ========== */
.login-card__close {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 50%;
  transition: background-color 0.2s ease;
  z-index: 1;
}

.login-card__close:hover {
  background-color: rgba(0, 0, 0, 0.06);
}

.login-card__close span {
  font-size: 22px;
  color: rgba(120, 120, 120, 1);
  line-height: 1;
}

/* ========== 顶部账号类型切换（标签式） ========== */
.login-card__account-tabs {
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  margin: 0 auto 30px;
  background: rgba(225, 236, 246, 0.55);
  border-radius: 24px;
  padding: 4px;
  box-sizing: border-box;
}

.login-card__account-tab {
  padding: 8px 28px;
  font-size: 16px;
  font-weight: 500;
  color: rgba(130, 130, 130, 1);
  line-height: 24px;
  cursor: pointer;
  border-radius: 20px;
  transition: all 0.25s ease;
  user-select: none;
  white-space: nowrap;
}

.login-card__account-tab--active {
  background: #FFFFFF;
  color: rgba(30, 30, 30, 1);
  font-weight: 600;
  box-shadow: 0 2px 10px rgba(35, 140, 200, 0.12);
}

.login-card__account-tab:not(.login-card__account-tab--active):hover {
  color: rgba(80, 80, 80, 1);
  background: rgba(255, 255, 255, 0.45);
}

/* ========== 登录/注册切换 ========== */
.login-card__sub-tabs {
  display: flex;
  align-items: center;
  gap: 42px;
  margin-bottom: 32px;
}

.login-card__sub-tab {
  position: relative;
  font-size: 20px;
  font-weight: 500;
  color: rgba(180, 180, 180, 1);
  line-height: 28px;
  cursor: pointer;
  transition: color 0.25s ease;
  user-select: none;
  padding-bottom: 10px;
}

.login-card__sub-tab--active,
.login-card__sub-tab:hover {
  color: rgba(30, 30, 30, 1);
}

.login-card__sub-tab--active::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 36px;
  height: 4px;
  background: #23B4DC;
  border-radius: 2px;
}

/* ========== 表单区域 ========== */
.login-card__form {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.login-card__form-item {
  width: 100%;
  margin-bottom: 18px;
}

.login-card__form-item:last-of-type {
  margin-bottom: 0;
}

.login-card__form-title {
  position: relative;
  width: 100%;
  font-size: 20px;
  font-weight: 600;
  color: rgba(30, 30, 30, 1);
  margin-bottom: 32px;
  padding-bottom: 10px;
  text-align: left;
}

.login-card__form-title::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 36px;
  height: 4px;
  background: #23B4DC;
  border-radius: 2px;
}

/* ========== 输入框 ========== */
.login-card__input-wrap {
  display: flex;
  align-items: center;
  width: 100%;
  height: 52px;
  background-color: #FFFFFF;
  border-radius: 26px;
  padding: 0 22px;
  border: 1px solid rgba(230, 240, 248, 0.8);
  box-sizing: border-box;
  transition: border-color 0.25s ease, box-shadow 0.25s ease;
}

.login-card__input-wrap:focus-within {
  border-color: rgba(35, 180, 220, 0.5);
  box-shadow: 0 0 0 3px rgba(35, 180, 220, 0.08);
}

.login-card__input-icon {
  width: 16px;
  height: 20px;
  flex-shrink: 0;
  object-fit: contain;
  opacity: 0.55;
}

.login-card__input-icon--lock {
  width: 16px;
  height: 18px;
}

.login-card__input-divider {
  width: 1px;
  height: 18px;
  background-color: rgba(210, 220, 230, 0.8);
  margin: 0 12px;
  flex-shrink: 0;
}

.login-card__input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 15px;
  color: rgba(40, 40, 40, 1);
  height: 100%;
  font-family: inherit;
}

.login-card__input::placeholder {
  color: rgba(180, 180, 180, 1);
  font-size: 14px;
}

/* ========== 验证码输入框 ========== */
.login-card__input-wrap--code {
  padding-right: 12px;
}

/* 验证码图片 */
.login-card__captcha-image {
  width: 80px;
  height: 40px;
  flex-shrink: 0;
  margin-left: -4px;
  cursor: pointer;
  border-radius: 4px;
  overflow: hidden;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-card__captcha-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.captcha-placeholder {
  font-size: 12px;
  color: #999;
  text-align: center;
}

.login-card__captcha-image:hover .captcha-placeholder {
  color: #23B4DC;
}

.login-card__code-btn {
  flex-shrink: 0;
  height: 34px;
  padding: 0 14px;
  border: none;
  border-radius: 17px;
  background-color: rgba(35, 180, 220, 0.1);
  color: #23B4DC;
  font-size: 13px;
  font-family: inherit;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
  white-space: nowrap;
}

.login-card__code-btn:hover:not(:disabled) {
  background-color: rgba(35, 180, 220, 0.18);
}

.login-card__code-btn:disabled {
  color: rgba(150, 150, 150, 1);
  background-color: rgba(200, 200, 200, 0.15);
  cursor: not-allowed;
}

/* ========== 密码提示 ========== */
.login-card__password-hint {
  width: 100%;
  margin-top: 6px;
  padding-left: 24px;
  box-sizing: border-box;
  color: #999;
  font-size: 12px;
  line-height: 16px;
}

/* ========== 错误提示 ========== */
.login-card__error {
  width: 100%;
  margin-top: 8px;
  padding-left: 24px;
  box-sizing: border-box;
}

.login-card__error span {
  display: inline-block;
  color: #FF4D4F;
  font-size: 12px;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
}

.login-card__form-error {
  width: 100%;
  margin-top: 8px;
  text-align: center;
}

.login-card__form-error span {
  color: #FF4D4F;
  font-size: 13px;
  line-height: 18px;
  font-family: inherit;
}

/* ========== 选项行 ========== */
.login-card__options {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 6px;
  margin-bottom: 6px;
}

.login-card__checkbox-wrap {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.login-card__checkbox {
  width: 14px;
  height: 14px;
  border: 1.5px solid #C0C0C0;
  border-radius: 3px;
  margin: 0;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  position: relative;
  background: #fff;
  flex-shrink: 0;
}

.login-card__checkbox:checked {
  background-color: #23B4DC;
  border-color: #23B4DC;
}

.login-card__checkbox:checked::after {
  content: '';
  position: absolute;
  left: 3px;
  top: 0px;
  width: 5px;
  height: 9px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.login-card__checkbox-label {
  margin-left: 8px;
  color: rgba(120, 120, 120, 1);
  font-size: 13px;
  line-height: 18px;
  user-select: none;
}

.login-card__forgot {
  color: #23B4DC;
  font-size: 13px;
  line-height: 18px;
  cursor: pointer;
  transition: opacity 0.2s ease;
  user-select: none;
}

.login-card__forgot:hover {
  opacity: 0.75;
}

/* ========== 同意协议 ========== */
.login-card__agree-row {
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 6px;
  cursor: pointer;
}

.login-card__agree-box {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  border: 1px solid #23B4DC;
  position: relative;
  background: #fff;
}

.login-card__agree-box--checked {
  background: #23B4DC;
}

.login-card__agree-inner {
  width: 8px;
  height: 6px;
  border-left: 2px solid #fff;
  border-bottom: 2px solid #fff;
  transform: rotate(-45deg);
  position: absolute;
  top: 2px;
  left: 1px;
}

.login-card__agree-text {
  font-size: 14px;
  color: rgba(120, 120, 120, 1);
  margin-left: 8px;
  user-select: none;
}

.login-card__back {
  margin-top: 16px;
  color: #23B4DC;
  font-size: 13px;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.login-card__back:hover {
  opacity: 0.75;
}

/* ========== 登录/注册/提交按钮 ========== */
.login-card__submit {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 52px;
  margin-top: 24px;
  background: #0091EA;
  border-radius: 26px;
  border: none;
  box-shadow: 0 4px 14px rgba(0, 145, 234, 0.35);
  color: #fff;
  font-size: 17px;
  font-weight: 600;
  letter-spacing: 4px;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;
  font-family: inherit;
}

.login-card__submit:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(0, 145, 234, 0.45);
}

.login-card__submit:active {
  transform: translateY(0);
  box-shadow: 0 2px 10px rgba(0, 145, 234, 0.30);
}

/* ========== 注册成功 ========== */
.login-card__success {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 0 20px;
}

.login-card__success-icon {
  margin-bottom: 20px;
}

.login-card__success-title {
  font-size: 22px;
  color: rgba(30, 30, 30, 1);
  font-weight: 600;
  margin-bottom: 12px;
}

.login-card__success-sub {
  font-size: 14px;
  color: rgba(150, 150, 150, 1);
  margin-bottom: 30px;
}

/* ========== 第三方登录 ========== */
.login-card__third-party {
  margin-top: 32px;
  text-align: center;
}

.login-card__third-party-text {
  display: block;
  color: rgba(150, 150, 150, 1);
  font-size: 12px;
  line-height: 18px;
  margin-bottom: 16px;
}

.login-card__third-party-icons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
}

.login-card__third-party-icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.2s ease, opacity 0.2s ease;
  padding: 2px;
  box-sizing: border-box;
  background: transparent;
}

.login-card__third-party-icon:hover {
  transform: scale(1.08);
  opacity: 0.9;
}

.login-card__third-party-icon img {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

/* ========== 微信登录弹窗样式 ========== */
/* ========== 微信登录新窗口样式 ========== */
.wechat-new-window-dialog,
.wechat-binding-dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.wechat-new-window-content {
  text-align: center;
  padding: 40px;
  max-width: 400px;
}

.wechat-close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 36px;
  height: 36px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  z-index: 1;
}

.wechat-close-btn:hover {
  background: #FFFFFF;
  transform: scale(1.1);
}

.wechat-close-btn span {
  font-size: 20px;
  color: #666666;
  line-height: 1;
}

.wechat-window-hint {
  animation: hint-fade-in 0.3s ease;
}

.wechat-window-hint p {
  margin: 12px 0;
  font-size: 15px;
  color: #333333;
  line-height: 1.6;
}

@keyframes hint-fade-in {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.wechat-binding-dialog .wechat-binding-content {
  position: relative;
  width: 500px;
  background: #FFFFFF;
  border-radius: 12px;
  padding: 32px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}

/* 绑定弹窗关闭按钮 */
.binding-close-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  z-index: 1;
}

.binding-close-btn:hover {
  background: #F0F0F0;
}

.binding-close-btn span {
  font-size: 16px;
  color: #999999;
  line-height: 1;
}

/* 绑定弹窗接口错误提示 */
.binding-api-error {
  width: 100%;
  margin-bottom: 16px;
  padding: 10px 12px;
  background: #FFF1F0;
  border: 1px solid #FFCCC7;
  border-radius: 4px;
  box-sizing: border-box;
}

.binding-api-error span {
  display: inline-block;
  color: #FF4D4F;
  font-size: 13px;
  line-height: 18px;
  word-break: break-word;
}

/* 绑定弹窗错误提示 */
.binding-error {
  width: 100%;
  margin-top: -8px;
  margin-bottom: 12px;
}

.binding-error span {
  display: inline-block;
  color: #FF4D4F;
  font-size: 12px;
  line-height: 18px;
}

.binding-title {
  margin: 0 0 24px;
  font-size: 20px;
  font-weight: bold;
  color: #333333;
  text-align: center;
}

.binding-input-row {
  width: 100%;
  margin-bottom: 16px;
}

.binding-mobile-input {
  height: 44px;
  padding: 0 16px;
  border: 1px solid #D9D9D9;
  border-radius: 4px;
  font-size: 14px;
  outline: none;
  background: #FFFFFF;
}

.binding-mobile-input:focus {
  border-color: #23B4DC;
  box-shadow: 0 0 0 2px rgba(35, 180, 220, 0.1);
}

.binding-captcha-row {
  display: flex;
  align-items: center;
  gap: 0;
  width: 100%;
  margin-bottom: 16px;
}

.binding-captcha-input {
  flex: 1;
  height: 44px;
  padding: 0 16px;
  border: 1px solid #D9D9D9;
  border-right: none;
  border-radius: 4px 0 0 4px;
  font-size: 14px;
  outline: none;
}

.binding-captcha-image {
  width: 100px;
  height: 44px;
  flex-shrink: 0;
  border: 1px solid #D9D9D9;
  border-radius: 0 4px 4px 0;
  overflow: hidden;
  cursor: pointer;
}

/* 协议链接样式 */
.agree-link {
  color: #23B4DC;
  text-decoration: none;
  margin: 0 4px;
  font-size: 14px;
}

.agree-link:hover {
  color: #1a8bb5;
  text-decoration: underline;
}

.binding-captcha-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.binding-sms-row {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  margin-bottom: 16px;
}

.binding-sms-input {
  flex: 1;
  height: 44px;
  padding: 0 16px;
  border: 1px solid #D9D9D9;
  border-radius: 4px;
  font-size: 14px;
  outline: none;
}

.binding-sms-btn {
  height: 44px;
  padding: 0 16px;
  min-width: 100px;
  background: rgba(35, 180, 220, 0.1);
  color: #23B4DC;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.binding-sms-btn:hover:not(:disabled) {
  background: rgba(35, 180, 220, 0.18);
}

.binding-sms-btn:disabled {
  color: #C8C9CC;
  background: #F5F5F5;
  cursor: not-allowed;
}

.binding-agree-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 24px;
  cursor: pointer;
  user-select: none;
}

.binding-checkbox {
  width: 16px;
  height: 16px;
  border: 1px solid #C8C9CC;
  border-radius: 3px;
  background: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.binding-checkbox.is-checked {
  background: #23B4DC;
  border-color: #23B4DC;
}

.binding-checkbox-inner {
  width: 8px;
  height: 5px;
  border-left: 2px solid #FFFFFF;
  border-bottom: 2px solid #FFFFFF;
  transform: rotate(-45deg);
}

.binding-agree-text {
  font-size: 13px;
  color: #666666;
  line-height: 16px;
}

.binding-submit-btn {
  flex: 1;
  height: 44px;
  background: #23B4DC;
  color: #FFFFFF;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s ease;
}

.binding-submit-btn:hover {
  background: #1CA3C9;
  box-shadow: 0 4px 12px rgba(35, 180, 220, 0.3);
}

/* 取消按钮 */
.binding-cancel-btn {
  flex: 1;
  height: 44px;
  background: #F5F5F5;
  color: #666666;
  border: 1px solid #D9D9D9;
  border-radius: 4px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s ease;
}

.binding-cancel-btn:hover {
  background: #E8E8E8;
  border-color: #C0C0C0;
}

/* 操作按钮行 */
.binding-button-row {
  display: flex;
  gap: 12px;
  width: 100%;
}
</style>
